import defaultResponse from "./routes/default";
import page2Response from "./routes/page2";
import titleJavaResponse from "./routes/title.java";
import checkBoxResponse from "./routes/checkbox.webapi";
import userInfo from "./routes/user.info";
import userUpdate from "./routes/user.update";


const response = {defaultResponse, page2Response, titleJavaResponse, checkBoxResponse, userInfo, userUpdate};
export default response;
